import { Injectable } from '@angular/core'
import { Response } from '@angular/http'
import 'rxjs/add/operator/map'
import { Globals } from '../helpers'
import { HttpInterceptor } from './http-error.interceptor'

@Injectable()
export class ActivationService {
  public serviceUrl: string
  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.serviceUrl = globals.url + 'activation'
  }

  public activate(activationId: string) {
    return this.http
      .post(this.serviceUrl, { activationId })
      .map((response: Response) => response.json())
  }

  public isActivated() {
    return this.http
      .get(this.serviceUrl)
      .map((response: Response) => (response ? response.json() : null))
  }
}
